module.exports = __webpack_public_path__ + "assetsclientes/img/camion-repartidor.c0dff725.svg";